import { motion } from 'motion/react';

import { useTranslation } from '../i18n/hooks';

export default function CTASection() {
  const t = useTranslation();
  return (
    <motion.section
      id="cta"
      className="gradient-bg relative mx-auto w-[86%] overflow-hidden rounded-3xl px-4 py-12 sm:px-6 sm:py-14 md:px-8 md:py-16 lg:px-32"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, margin: '-100px' }}
    >
      {/* Background Lines */}
      <motion.div
        className="absolute top-2 left-0 h-[3px] w-full bg-black/60 blur-2xl"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ delay: 0.2, duration: 1, ease: 'easeOut' }}
        viewport={{ once: true }}
      ></motion.div>
      <motion.div
        className="absolute bottom-0 left-0 h-[3px] w-full bg-black/40 blur-2xl"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ delay: 0.4, duration: 1, ease: 'easeOut' }}
        viewport={{ once: true }}
      ></motion.div>

      <motion.div
        className="relative z-10 text-center text-white"
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
      >
        <motion.h2
          className="mb-3 px-2 text-2xl font-bold sm:mb-4 sm:text-3xl md:text-3xl lg:text-4xl"
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          viewport={{ once: true }}
        >
          {t.cta.title}
        </motion.h2>
        <motion.p
          className="mx-auto mb-6 max-w-full px-2 text-base sm:mb-8 sm:max-w-2xl sm:text-lg md:max-w-3xl md:text-xl"
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.6 }}
          viewport={{ once: true }}
        >
          {t.cta.description}
        </motion.p>
        <motion.button
          className="mx-auto w-full max-w-xs rounded-md bg-green-600 px-6 py-2.5 text-sm font-bold text-white transition-colors hover:bg-green-700 sm:w-auto sm:px-20 sm:py-3 sm:text-base md:px-20 lg:px-28"
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.6 }}
          viewport={{ once: true }}
          whileHover={{
            scale: 1.05,
            backgroundColor: '#15803d',
            boxShadow: '0 10px 25px rgba(34, 197, 94, 0.4)',
          }}
          whileTap={{ scale: 0.95 }}
        >
          <a
            href="https://patient.tc.tgl.com.sa/signin"
            target="_blank"
            rel="noreferrer"
          >
            {t.cta.button}
          </a>
        </motion.button>
      </motion.div>
    </motion.section>
  );
}
